import { ui } from '@owenscorning/pcb.alpha';

import Article from './Article';

const Newsroom = Article(
  'Article::Newsroom',
  'newsroom_blog',
  ['SocialMediaShareBanner', 'RelatedArticles'],
  ui`AttributeSet`({
    query: {
      name: 'Corporate Newsroom',
      path: '/news/news-releases',
    },
  }),
  {
    version: '0.1',
    displayName: 'Newsroom Articles',
    paths: ['news/news-releases'],
  }
);

export default Newsroom;
